import reducer from "./reducers";
import { routes } from "../routes";
import * as randMsgOperations from "./operations";
import selectors from "./selectors";

export {
    randMsgOperations,
    selectors
};

export default {
    reducer,
    routes
};
